import { ActivatedRouteSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { LoggingService } from '../../shared/services/core/logging.service';
import { AddressService } from './address.service';
import { MemberQuery } from '../member/member.query';
import { AuthService } from '../../user/services/auth.service';
import { AccountStatus } from '../member/models/account-status.model';

@Injectable({ providedIn: 'root' })
export class AddressResolver {
  constructor(
    private addressService: AddressService,
    private logService: LoggingService,
    private memberQuery: MemberQuery,
    private authService: AuthService
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const user = this.memberQuery.getValue().user;
    //Only fetch the latest addresses when we know the user is logged in
    if (user && this.authService.isAuthenticated() && this.memberQuery.getUserContext().status !== AccountStatus.FirstTimeUser) {
      this.logService.info('Resolving addresses');
      return this.addressService.fetchAddresses();
    }
    return of(null);
  }
}
